import ReactDOM from "react-dom";
import App from "./App";
import "./common/styles/theme.css"
import "./index.scss";

ReactDOM.render( <App />, document.getElementById("root"));